import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Person } from '../entities';

interface PersonContextProps {
  person: Person | null;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setPerson: React.Dispatch<React.SetStateAction<Person | null>>;
  handleSelectPerson: (newPerson: Person) => void;
  handleUnselectPerson: () => void;
}

export const PersonContext = createContext<PersonContextProps>({} as PersonContextProps);

export const usePersonContext = () => useContext(PersonContext);

export const PersonProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  const [person, setPerson] = useState<Person | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSelectPerson = (newPerson: Person) => {
    setPerson(person);
    navigate(`/persons/${newPerson.id}`);
  };

  const handleUnselectPerson = () => {
    setPerson(null);
    navigate('/persons');
  };

  return (
    <PersonContext.Provider value={{ person, loading, setLoading, setPerson, handleSelectPerson, handleUnselectPerson }}>
      {children}
    </PersonContext.Provider>
  );
};
